import {
  Button,
  Col,
  Input,
  Pagination,
  Popover,
  Row, Skeleton,
  DatePicker,
  Table
} from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FaEye, FaSearch } from "react-icons/fa";
import { MdTune } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { extractDate } from "../../config/helpers";
import { Get } from "../../config/api/get";
import { CHATS, UPLOADS_URL } from "../../config/constants/api";
import { useDebouncedCallback } from "use-debounce";
import moment from "moment";
  
  const UserManagement = () => {
    const token = useSelector((state) => state.user.userToken);
    const [chats, setChats] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [paginationConfig, setPaginationConfig] = useState({
      pageNumber: 1,
      limit: 10,
      totalDocs: 0,
      totalPages: 0,
    });
  
    const [filter, setFilter] = useState({
      status: null,
      type: null,
      keyword: "",
      from: null,
      to: null,
      membership : null
    });
    const getUsers = (pageNumber, pageSize, from, to, keyword) => {
      setLoading(true);
      Get(CHATS.fetchAllChats, token, {
        from,
        to,
        keyword,
        page: pageNumber
          ? pageNumber.toString()
          : paginationConfig.pageNumber.toString(),
        limit: pageSize ? pageSize.toString() : paginationConfig.limit.toString(),
      })
        .then((response) => {
          if (response?.status) {
            setChats(response?.data?.docs);
            setPaginationConfig({
              pageNumber: response?.data?.page,
              limit: response?.data?.limit,
              totalDocs: response?.data?.totalDocs,
              totalPages: response?.data?.totalPages,
            });
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log("Error Fetching Loads", err);
          setLoading(false);
        });
    };
    useEffect(() => {
      getUsers();
      // eslint-disable-next-line
    }, []);
    // const capitalizeFirstLetter = (str) => {
    //   return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    // };
  
    const handlePageChange = (pageNumber) => {
      setPaginationConfig({
        ...paginationConfig,
        pageNumber: pageNumber,
      });
      getUsers(pageNumber, paginationConfig.limit);
    };
  
    const handleSearch = useDebouncedCallback((value) => {
      setFilter({
        ...filter,
        keyword: value,
      });
      getUsers(
        paginationConfig.pageNumber,
        paginationConfig.limit,
        null,
        null,
        value
      );
    }, 1000);
  
    // const handleStatusChange = (value) => {
    //   setFilter({
    //     ...filter,
    //     status: value,
    //   });
    // };
    // const handleMembershipChange = (value) => {
    //   setFilter({
    //     ...filter,
    //     membership: value,
    //   });
    // };
  
    // const handleTypeChange = (value) => {
    //   setFilter({
    //     ...filter,
    //     type: value,
    //   });
    // };
  
    const resetFilter = () => {
      setFilter({
        status: null,
        keyword: "",
        from: null,
        to: null,
      });
    };
  
    const handleOpenChange = (newOpen) => {
      setOpen(newOpen);
    };
  
    const handleFrom = (date) => {
      setFilter({
        ...filter,
        from: date,
      });
    };
  
    const handleTo = (date) => {
      setFilter({
        ...filter,
        to: date,
      });
    };
    const data = {
      status: filter.status,
      keyword: filter.keyword,
      from: filter.from,
      to: filter.to,
      membership: filter.membership,
    };
    const handleApply = () => {
      let from;
      let to;
   
      if (data.from) {
        from = moment(filter?.from?.$d).format("YYYY-MM-DD");
      }
      if (data.to) {
        to = moment(filter?.to?.$d).format("YYYY-MM-DD");
      }
      if (from || to ) {
        getUsers(
          paginationConfig.pageNumber,
          paginationConfig.limit,
          from,
          to,
      
        );
      } else {
        return;
      }
    };
    const handleClear = () => {
      resetFilter();
      getUsers();
    };
  
    const startIndex =
      (paginationConfig.pageNumber - 1) * paginationConfig.limit + 1;
    const endIndex = Math.min(
      startIndex + paginationConfig.limit - 1,
      paginationConfig.totalDocs
    );
    const message = chats
    ? `Showing records ${endIndex} of ${paginationConfig.totalDocs}`
    : "Showing records 0 of 0";
  
  
    const itemRender = (_, type, originalElement) => {
      if (type === "prev") {
        return (
          <button type="button" className="pagination-link">
            Previous
          </button>
        );
      }
      if (type === "next") {
        return (
          <button type="button" className="pagination-link">
            Next
          </button>
        );
      }
  
      return originalElement;
    };
    const filterContent = (
      <div className="filterDropdown">
        <div>
          <p
            className="mainLabel"
            style={{ padding: "10px", fontSize: "18px", fontWeight: "bold" }}
          >
            Filter
          </p>
        </div>
        <hr style={{ marginBottom: 10 }} />
  
        <div className="filterDropdownBody">
          <p className="mainLabel">From:</p>
          <DatePicker
            className="mainInput filterInput web-input"
            value={filter.from}
            onChange={(e) => handleFrom(e)}
            style={{ width: "100%" }}
          />
          <p className="mainLabel">To:</p>
          <DatePicker
            className="mainInput filterInput web-input"
            value={filter.to}
            onChange={(e) => handleTo(e)}
            style={{ width: "100%" }}
          />
  
          <Button
            type=""
            block
            size={"large"}
            style={{ marginBottom: "10px" }}
            className="web-btn"
            //   onClick={() => getUsers()}
            onClick={handleApply}
          >
            Apply
          </Button>
          <Button
            type=""
            block
            size={"large"}
            className="web-btn"
            onClick={handleClear}
          >
            Clear All
          </Button>
        </div>
      </div>
    );
  
    const columns = [
      {
        title: (
          <p className="uppercase font-euclid text-black font-bold text-xs text-center">
            S.NO
          </p>
        ),
        dataIndex: "key",
        key: "key",
        render: (value, item, index) => (
          <p className="text-xs text-center font-euclid text-[#575757]">
            {(index < 10 && "0") + (index + 1)}
          </p>
        ),
      },
      {
        title: (
          <p className="uppercase font-euclid text-black font-bold text-xs text-center">
            User image
          </p>
        ),
        dataIndex: "user",
        key: "user",
        render: (value, item, index) => {
          const handleImageError = (e) => {
            e.target.src = "/assets/images/avatar.png";
          };
          
          const imageSrc = value?.image 
            ? UPLOADS_URL + value.image 
            : "/assets/images/avatar.png";
          
          return (
            <div className="flex justify-center">
              <img 
                src={imageSrc} 
                alt="profile" 
                onError={handleImageError}
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                }}
              />
            </div>
          );
        },
      },
      {
        title: (
          <p className="uppercase font-euclid text-black font-bold text-xs text-center">
            chauffeur image
          </p>
        ),
        dataIndex: "chauyffeur",
        key: "chauyffeur",
        render: (value, item, index) => {
          const handleImageError = (e) => {
            e.target.src = "/assets/images/avatar.png";
          };
          
          const imageSrc = value?.image 
            ? UPLOADS_URL + value.image 
            : "/assets/images/avatar.png";
          
          return (
            <div className="flex justify-center">
              <img 
                src={imageSrc} 
                alt="profile" 
                onError={handleImageError}
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                }}
              />
            </div>
          );
        },
      },
      {
        title: (
          <p className="uppercase font-euclid text-black font-bold text-xs text-center">
           User Name
          </p>
        ),
        dataIndex: "user",
        key: "user",
        render: (value, item, index) => (
          <div className="flex flex-col items-center justify-center">
            <p className="text-xs text-center font-euclid text-[#575757]">
              {value?.firstName + " " + value?.lastName}
            </p>
          </div>
        ),
      },
      {
        title: (
          <p className="uppercase font-euclid text-black font-bold text-xs text-center">
           chauffeur Name
          </p>
        ),
        dataIndex: "chauffeur",
        key: "chauffeur",
        render: (value, item, index) => (
          <div className="flex flex-col items-center justify-center">
            <p className="text-xs text-center font-euclid text-[#575757]">
              {value?.firstName + " " + value?.lastName}
            </p>
          </div>
        ),
      },
      {
        title: (
          <p className="uppercase font-euclid text-black font-bold text-xs text-center">
           Date
          </p>
        ),
        dataIndex: "createdAt",
        key: "name",
        render: (value, item, index) => (
          <div className="flex flex-col items-center justify-center">
            <p className="text-xs text-center font-euclid text-[#575757]">
              {extractDate(value)}
            </p>
          </div>
        ),
      },
  
      // {
      //   title: (
      //     <p className="uppercase font-euclid text-black font-bold text-xs text-center">
      //       status
      //     </p>
      //   ),
      //   dataIndex: "status",
      //   key: "status",
      //   render: (value, item, index) => (
      //     <div className="flex justify-center customSwitch2">
      //       <Switch defaultChecked />
      //     </div>
      //   ),
      // },
      {
        title: (
          <p className="uppercase font-euclid text-black font-bold text-xs text-center">
            action
          </p>
        ),
        dataIndex: "_id",
        key: "_id",
        render: (value, item, index) => (
          <div className="flex justify-center">
            <div className="flex justify-center bg-[#9CFEC4] rounded-[100%] w-fit p-2">
              <FaEye
                className="text-[#089B44] cursor-pointer h-[16px] w-[16px]"
                onClick={() => navigate("/messagesDetails/" + item._id ,  { state: { data : item }})}
              />
             
            </div>
          </div>
        ),
      },
    ];
  
    return (
      <Row justify="center">
        <Col md={23} xs={22}>
          <div className="flex justify-between items-center mt-8">
            <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black ml-8">
              Messages
            </h3>
            <div className="flex justify-center items-center">
              <Input
                style={{ width: "250px" }}
                className="mainInput dashInput h-full"
                placeholder="Search"
                onChange={(e) =>
                  handleSearch(e.target.value)
                }
                //   onChange={(e) => handleSearch(e.target.value)}
                suffix={
                  <FaSearch
                    style={{
                      color: "#818181",
                      fontSize: 16,
                      cursor: "pointer",
                    }}
                    //   onClick={() =>
                    //     getUsers(1, paginationConfig.limit, filter.keyword)
                    //   }
                  />
                }
                //   onPressEnter={(e) =>
                //     getUsers(1, paginationConfig.limit, filter.keyword)
                //   }
              />
              &emsp;
              <Popover
                content={filterContent}
                trigger="click"
                open={open}
                onOpenChange={handleOpenChange}
                placement="bottomRight"
                arrow={false}
              >
                <Button
                  style={{
                    padding: "4px 11px",
                    height: "auto",
                    borderRadius: "6px",
                    backgroundColor: "white",
                  }}
                >
                  <MdTune style={{ fontSize: "32px", color: "#767676" }} />
                </Button>
              </Popover>
              &emsp;
              {/* <button
                className="uppercase bg-button py-3 px-4 xl:px-16 text-black rounded-lg font-bold text-sm max-md:text-[10px] max-md:py-2 max-md:px-4 font-euclid"
                onClick={() => navigate("/addUser")}
              >
                +add
              </button> */}
            </div>
          </div>
          <div
            className="bg-white rounded-lg  py-8 my-8"
            style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
          >
            <Row style={{ overflow: "auto" }} className="px-6">
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Skeleton active />
                  <br />
                </div>
              ) : (
                <Table
                  className="styledTable"
                  dataSource={chats}
                  columns={columns}
                  pagination={false}
                />
              )}
            </Row>
            <Row style={{ padding: "10px 20px" }}>
              <Col xs={24} md={12}>
                <p className="font-euclid text-sm text-black">{message}</p>
              </Col>
              <Col
                xs={24}
                md={12}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Pagination
                  className="styledPagination"
                  onChange={(e) => handlePageChange(e)}
                  current={parseInt(paginationConfig.pageNumber)}
                  pageSize={paginationConfig.limit}
                  total={paginationConfig.totalDocs}
                  itemRender={itemRender}
                />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    );
  };
  
  export default UserManagement;
  